import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@sumologic/yama-ds-components/hooks';

import BlankSpacePlaceholder from '~/components/BlankSpacePlaceholder/BlankSpacePlaceholder';
import Translate from '~/components/Translate/Translate';
import { IconActLightAsset, IconActDarkAsset } from '@sumologic/yama-ds-assets';

const NoDataToShow = ({
    className,
    actions,
    description,
    width = 72,
    height = 72,
    title
}) => {
    const currentTheme = useTheme()?.palette?.mode || 'dark';
    const IconActAsset =
        currentTheme === 'light' ? IconActLightAsset : IconActDarkAsset;

    return (
        <BlankSpacePlaceholder
            img={<IconActAsset width={width} height={height} />}
            className={`nodatatoshow ${className || 'standard'}`}
            title={title}
            description={description}
            actions={actions}
        />
    );
};

NoDataToShow.propTypes = {
    className: PropTypes.string,
    actions: PropTypes.element,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    width: PropTypes.number,
    height: PropTypes.number,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

NoDataToShow.defaultProps = {
    title: <Translate message="Nothing to see here" />
};

export default NoDataToShow;
